import Icon from "@material-ui/core/Icon"
import Link from "@material-ui/core/Link"
import Typography from "@material-ui/core/Typography"
import LocationOnRoundedIcon from "@material-ui/icons/LocationOnRounded"
import React from "react"
import styled from "styled-components"

interface IProps {
  location: Maybe<string>
}

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.palette.secondary.dark};
`

const LocationLink: React.FC<IProps> = ({ location }) => {
  if (!location) return null

  const baseMapsLink = "https://www.google.nl/maps/place/"
  const locationParameter = location.replace(/\s/g, "+")

  return (
    <Typography variant="h6" align="center" component="p" gutterBottom>
      <StyledLink
        href={`${baseMapsLink}${locationParameter}`}
        target="_blank"
        rel="noopener"
      >
        <Icon>
          <LocationOnRoundedIcon />
        </Icon>
        {location}
      </StyledLink>
    </Typography>
  )
}

export default LocationLink
